import { createContext, useReducer, useContext } from 'react'

interface IAirdropStateType {
  selectedTransactionsTotal: any
  signer: any | null
  initiator: string
  signXPortal: boolean
  externalWallet: boolean
}

const storedAirdropStateJson = sessionStorage.getItem('airdropState')
const storedAirdropState = storedAirdropStateJson ? JSON.parse(storedAirdropStateJson) : null

const initialAirdropState = {
  selectedTransactionsTotal: null,
  signer: null,
  initiator: '',
  signXPortal: storedAirdropState?.signXPortal || false,
  externalWallet: storedAirdropState?.externalWallet || false,
}

interface IAirdropAction {
  type: 'SELECTEDTXTOTAL' | 'SIGNER' | 'INITIATOR' | 'SIGNXPORTAL' | 'EXTERNALWALLET' | null
  payload: any
}

export const AirdropContext = createContext(initialAirdropState)
export const AirdropDispatchContext = createContext({} as any)

const airdropReducer = (state: IAirdropStateType, action: IAirdropAction) => {
  const { type, payload } = action
  switch (type) {
    case 'SIGNXPORTAL':
      const newXState = {
        ...state,
        signXPortal: payload,
      }
      sessionStorage.setItem(
        'airdropState',
        JSON.stringify({
          signXPortal: payload,
          externalWallet: newXState.externalWallet,
        }),
      )
      return newXState
    case 'EXTERNALWALLET':
      const newExternalState = {
        ...state,
        externalWallet: payload,
      }
      sessionStorage.setItem(
        'airdropState',
        JSON.stringify({ externalWallet: payload, signXPortal: false }),
      )
      return newExternalState
    case 'SELECTEDTXTOTAL':
      const newSelectedTotalState = {
        ...state,
        selectedTransactionsTotal: payload,
      }
      return newSelectedTotalState
    case 'SIGNER':
      const newSignerState = {
        ...state,
        signer: payload,
      }
      return newSignerState
    case 'INITIATOR':
      const newInitiatorState = {
        ...state,
        initiator: payload,
      }
      return newInitiatorState
    default:
      return state
  }
}

export const AirdropProvider = ({ children }: any) => {
  const [airdropState, airdropDispatch] = useReducer(airdropReducer, initialAirdropState)

  return (
    <AirdropContext.Provider value={airdropState}>
      <AirdropDispatchContext.Provider value={airdropDispatch}>
        {children}
      </AirdropDispatchContext.Provider>
    </AirdropContext.Provider>
  )
}

export function useAirdropState() {
  return useContext(AirdropContext)
}

export function useAirdropDispatch() {
  return useContext(AirdropDispatchContext)
}
